import React from 'react';
import ServicePartnerForm from '../components/ServicePartnerForm/ServicePartnerForm';

const AddServicePartner = () => {
    return <ServicePartnerForm />;
};

export default AddServicePartner;
